const userActionConstants = {
  UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
  GET_EMAILS: 'GET_EMAILS',
  CREATE_EMAIL: 'CREATE_EMAIL',
  DELETE_EMAIL: 'DELETE_EMAIL',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  UPDATE_PRIMARY_EMAIL: 'UPDATE_PRIMARY_EMAIL',
  CREATE_EXP_REWARD_DETAILS: 'CREATE_EXP_REWARD_DETAILS',
  GET_EXP_REWARD_DETAILS: 'GET_EXP_REWARD_DETAILS',
  GET_URL_PROFILE_DETAILS: 'GET_URL_PROFILE_DETAILS',
  DELETE_COVER_IMAGE: 'DELETE_COVER_IMAGE',
};
export default userActionConstants;
